import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes intelligently. Shadcn convention.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Format a number as a two-digit editorial section marker (e.g. 01, 02, 17).
 * Used by marginalia and How-It-Works step numbers.
 */
export function sectionNumber(n: number): string {
  return n.toString().padStart(2, '0');
}

/**
 * Produce an ISO-ish short date in the form "Nov 2026". Used in footers
 * and project cards.
 */
export function shortMonthYear(d: Date = new Date()): string {
  return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}
